// function slideUp(target, duration = 1000) {
//   // 最大高さを定義
//   const maxHeight = '290px'; // または、ビューポートに基づく計算値

//   target.animate(
//     [
//       { height: target.dataset.height, paddingTop: target.dataset.paddingtop, paddingBottom: target.dataset.paddingbottom, opacity: '1' },
//       { height: maxHeight, paddingTop: '0', paddingBottom: '0' }
//     ],
//     {
//       duration: duration,
//       fill: 'forwards',
//       easing: 'ease-in-out'
//     }
//   );
// }

// function slideDown(target, duration = 1000) {
//   target.style.display = 'block';
//   target.animate(
//     [
//       { height: '290px', paddingTop: '0', paddingBottom: '0' },
//       { height: target.dataset.height, paddingTop: target.dataset.paddingtop, paddingBottom: target.dataset.paddingbottom, opacity: '1' }
//     ],
//     {
//       duration: duration,
//       fill: 'forwards',
//       easing: 'ease-in-out'
//     }
//   );
// }

// function slideToggle(target, duration = 1000) {
//   if (target.style.display === 'none' || window.getComputedStyle(target).display === 'none') {
//     slideDown(target, duration);
//   } else {
//     slideUp(target, duration);
//   }
// }

window.addEventListener('load', () => {
  if (document.querySelectorAll('.js-more').length === 0) {
    return;
  }

  const more = document.querySelectorAll('.js-more');
  more.forEach(el => {
    const target = el.previousElementSibling;
    // console.log(target.clientHeight)
    target.dataset.baseheight = target.clientHeight
    target.style.height = 'auto'
    target.dataset.height = target.clientHeight
    target.style.height = ''

    if (Number(target.dataset.height) > 290 ) {

      el.addEventListener('click', () => {
        if (el.classList.contains('active')) {
          // target.classList.toggle('active');
          target.style.height = `${target.dataset.baseheight}px`
        } else {
          target.style.height = `${target.dataset.height}px`
  
        }
        el.classList.toggle('active');//クラスを切り替えている
        // テキストの切り替えを簡素化
        el.textContent = el.textContent === 'もっと見る' ? 'とじる' : 'もっと見る';
      });
    } else {
      el.style.display = 'none'
      target.style.height = 'auto'

    }
  });

})

